import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';

class DSSpinnerComponent {
    isNegative = false;
    alignment = 'NONE';
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.4", ngImport: i0, type: DSSpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.4", type: DSSpinnerComponent, isStandalone: true, selector: "lib-spinner, ds-spinner", inputs: { isNegative: "isNegative", alignment: "alignment" }, ngImport: i0, template: "<div\n\tclass=\"rs-spinner\"\n\t[class.rs-no-margin-left]=\"alignment === 'LEFT'\"\n\t[class.rs-no-margin-right]=\"alignment === 'RIGHT'\"\n\trole=\"alert\"\n\taria-live=\"polite\"\n\taria-label=\"Loading\"\n\ttitle=\"Loading\"\n\taria-busy=\"true\"\n></div>", changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.4", ngImport: i0, type: DSSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-spinner, ds-spinner', changeDetection: ChangeDetectionStrategy.OnPush, imports: [NgClass, NgIf], template: "<div\n\tclass=\"rs-spinner\"\n\t[class.rs-no-margin-left]=\"alignment === 'LEFT'\"\n\t[class.rs-no-margin-right]=\"alignment === 'RIGHT'\"\n\trole=\"alert\"\n\taria-live=\"polite\"\n\taria-label=\"Loading\"\n\ttitle=\"Loading\"\n\taria-busy=\"true\"\n></div>" }]
        }], propDecorators: { isNegative: [{
                type: Input
            }], alignment: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { DSSpinnerComponent };
